import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { 
  Network, 
  Shield, 
  CheckCircle, 
  TrendingDown, 
  Settings
} from 'lucide-react';

const BrokerageFeatures = () => {
  const brokerageFeatures = [
    {
      title: "Premium Network Deals, Unlocked",
      description: "We unlock premium carrier deals traditionally reserved for MSPs and wholesale operators, bypassing volume and licensing gatekeeping.",
      icon: Shield
    },
    {
      title: "We Know All the Players",
      description: "AT&T. Windstream. Verizon. Lumen. Spectrum. And more. We've worked with them all—and we know the system.",
      icon: Network
    },
    {
      title: "We Know the Pain Points",
      description: "IP Justification, Billing Support, SLAs & Downtime—we help you navigate it all.",
      icon: Settings
    },
    {
      title: "We Engineer Around Pricing Traps",
      description: "We shift entry points without disrupting delivery to save you thousands.",
      icon: TrendingDown
    },
    {
      title: "We Unlock Hidden Promotions",
      description: "Month 1 free, 3-month 20% discounts, bulk commits waived—we ask for what others don't know exists.",
      icon: CheckCircle
    }
  ];

  return (
    <section className="py-16 bg-white section-pulse">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            What Makes NEXX the Smartest Brokerage Partner
          </h2>
          <p className="text-xl text-gray-600">
            75+ carriers, real expertise, engineering-first approach
          </p>
        </div>

        <Accordion type="single" collapsible className="max-w-4xl mx-auto">
          {brokerageFeatures.map((feature, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="border-b border-gray-200">
              <AccordionTrigger className="text-left hover:no-underline">
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-nexx-green/10 rounded-lg">
                    <feature.icon className="h-5 w-5 text-nexx-green" />
                  </div>
                  <span className="text-lg font-semibold">{feature.title}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pt-4 pb-6 pl-16">
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                {feature.title === "We Know the Pain Points" && (
                  <ul className="mt-4 space-y-2 text-gray-600">
                    <li className="flex items-center gap-2">
                      <CheckCircle className="h-4 w-4 text-nexx-green" />
                      <strong>IP Justification:</strong> We help tailor and translate your business use into compliant, accepted requests
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="h-4 w-4 text-nexx-green" />
                      <strong>Billing Support:</strong> When disputes happen, we know who to call—and what to say
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="h-4 w-4 text-nexx-green" />
                      <strong>SLAs & Downtime:</strong> We help you trigger service credits and hold ISPs accountable
                    </li>
                  </ul>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default BrokerageFeatures;
